import axios from '@/utils/api'

const actions = {
  async findByFilter ({ commit }, filter) {
    return axios({
      url: `processo/filter`,
      method: 'POST',
      data: filter
    })
  },

  async trocarResponsavel ({ commit }, { id, idUsuario }) {
    return axios({
      method: 'PUT',
      url: `processo/alterarResponsavel/${id}`,
      data: idUsuario
    })
  },

  async getInfoAnaliseById ({ commit }, id) {
    return axios({
      method: 'GET',
      url: `processo/infoAnalise/${id}`
    })
  },
  async getInfoAnaliseCertificacaoById ({ commit }, id) {
    return axios({
      method: 'GET',
      url: `processo/infoAnaliseCertificacao/${id}`
    })
  },

  async iniciarAnaliseById ({ commit }, id) {
    return axios({
      method: 'POST',
      url: `processo/iniciarAnalise/${id}`
    })
  },
  async iniciarAnaliseCertificacaoById ({ commit }, id) {
    return axios({
      method: 'POST',
      url: `processo/iniciarCertificacao/${id}`
    })
  },

  async getAcoesTramitacaoById ({ commit }, id) {
    return axios({
      method: 'GET',
      url: `processo/tramitacao/acoes/${id}`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/processo.js